<template>
  <transition name="fade" mode="out-in">
    <section class="pay-result">
      <top-header
        class="page-top-header"
        :showLangSelector="false"
      ></top-header>
      <div class="result-info-container">
        <em class="result-icon storing"></em>
        <p class="result-tips" v-html="letter.browserPayingTips"></p>
      </div>
      <div class="follow-operation">
        <Button
          class="follow-operation-btn contact-us"
          @click="showFeebackPage"
          pointClass="j-go-feeback-btn"
        >
          {{ letter.browserPayErrBtnText }}
        </Button>
        <Button
          class="follow-operation-btn"
          pointClass="j-restore-btn"
          @click="backGame"
        >
          {{ letter.browserPaySucBtnText }}
        </Button>
      </div>
    </section>
  </transition>
</template>
<script>
import TopHeader from '@components/officialWebStore/TopHeader.vue';
import bridge from '@utiles/officialStore/bridge';
import { FEEKBACK_URL } from '@utiles/officialStore/index';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV2';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
const OPEN_BROSWER_METHOD = 'openBrowser';
export default {
  name: 'waitPage',
  computed: {
    letter() {
      return this.$store.state.letter;
    }
  },
  methods: {
    showFeebackPage() {
      clickButton({
        btnName: 'contact_service',
        locationKey: locationType.browserPay
      });
      bridge.callSdkMethod(OPEN_BROSWER_METHOD, {
        url: getGlobalGetGotoLink({ link: FEEKBACK_URL }),
        loginDir: 1,
        appendParams: 1
      });
    },
    backGame() {
      setTimeout(() => {
        clickButton({
          btnName: 'back_game',
          locationKey: locationType.browserPay
        });
        bridge.callSdkMethod('closeWebview');
      });
    }
  },
  components: {
    TopHeader
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/officialWebStore.scss';
.pay-result {
  position: relative;
  background: #f6f6f6;
  min-height: 100%;
}
.page-top-header {
  position: relative;
}
.result-info-container {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 0 20px;
  color: #666;
  font-size: 26px;
  width: 100%;
  .result-tips {
    line-height: 40px;
    text-align: center;
    margin-top: 50px;
  }
}

.follow-operation {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 30px;
  width: 613px;
  margin: 45px auto;
  &.center {
    justify-content: center;
  }
  .follow-operation-btn {
    width: 100%;
    height: 80px;
    line-height: 80px;
    font-size: 26px;
    color: #fff;
    border-radius: 40px;
    cursor: pointer;
    padding: 0 30px;
    background: $btnBg;
    margin-bottom: 20px;
    &.contact-us {
      background: $popupSubBtn;
      cursor: pointer;
    }
  }
}
.result-icon {
  display: block;
  margin: 0 auto;
  background: url($tmslgImg + 'result-storing-ico.png') no-repeat;
  width: 150px;
  height: 150px;
  background-size: cover;
}
@media screen and (orientation: landscape) {
  .result-info-container {
    top: 40%;
  }
  .result-icon {
    width: 100px;
    height: 100px;
  }
  .follow-operation {
    bottom: 0;
    margin-bottom: 10px;
  }
}
</style>
